import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackEventBaseParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/trackEvent";

/* ---------------------------------------------------------------------------------------------------- */
// Custom Event
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackReorderOrderParameters extends TrackEventBaseParameters {}

const trackReorderOrder = (parameters: TrackReorderOrderParameters, options?: Toolkit.GoogleAnalytics.Options) => {
    return ga.track.event({ action: "reorder_order", ...parameters }, options);
};

export default trackReorderOrder;
